import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { trackDailyrentBannerClick, trackDailyrentBannerShow } from './tracking';
import { DailyrentBanner } from '../../components/DailyrentBanner';
import { useApplicationContext } from 'shared/utils/applicationContext';

export function DailyrentBannerContainer() {
  const { config } = useApplicationContext();
  const bannerUrl = config.get<string>('DailyRent.ListingDesktopBanner.Url') || 'https://www.cian.ru/posutochno/';

  return (
    <ActionAfterViewObserver callback={trackDailyrentBannerShow} percentVisible={0.8} triggerOnce>
      <DailyrentBanner url={bannerUrl} onClick={trackDailyrentBannerClick} />
    </ActionAfterViewObserver>
  );
}
